import { render, staticRenderFns } from "./DepartmentsCards.vue?vue&type=template&id=20b09ad2&scoped=true&"
import script from "./DepartmentsCards.vue?vue&type=script&lang=js&"
export * from "./DepartmentsCards.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentsCards.vue?vue&type=style&index=0&id=20b09ad2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b09ad2",
  null
  
)

export default component.exports